import React from 'react';


export default function MatchResult(props) {
	return (
		<div>
			<button onClick={() => props.add(props.gym)}>Add</button> &nbsp;
			{props.gym.name}
		</div>
	);
};

